import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBoxMaxLine1Footnote6 } from 'atoms/TextBox/Templates/TextBoxMaxLine1Footnote6'
import { TextBoxMaxLine2Body5 } from 'atoms/TextBox/Templates/TextBoxMaxLine2Body5'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockHorizontalType3 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockHorizontalType3 = ({
  title,
  description,
  ...rest
}: ITextBlockHorizontalType3): JSX.Element => {
  return (
    <TextBlock {...rest}>
      <TextBoxMaxLine1Footnote6 title={title} />
      {description && <TextBoxMaxLine2Body5 title={description} />}
    </TextBlock>
  )
}
